import React, { Suspense } from "react";
import { useTranslation } from "react-i18next";
import { Navigate, useLocation } from "react-router-dom";
import { buildAuthRequiredPath } from "../../utils/authRedirect";

const MapSearch = React.lazy(() => import("./MapSearch"));

class MapRouteBoundary extends React.Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    console.error("[MapSearch] route failed to load or render", error, info);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div role="alert" className="mx-auto max-w-md px-6 py-12 text-center text-white">
        <p>{this.props.errorLabel}</p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="mt-5 rounded-full bg-white px-6 py-3 font-semibold text-[#19233A]"
        >
          {this.props.reloadLabel}
        </button>
      </div>
    );
  }
}

export default function MapSearchRoute(props) {
  const { t } = useTranslation("common");
  const location = useLocation();
  if (props.isGuest) {
    return <Navigate to={buildAuthRequiredPath({ next: `${location.pathname}${location.search}` })} replace />;
  }
  return (
    <MapRouteBoundary
      key={location.key}
      errorLabel={t("mapRoute.error")}
      reloadLabel={t("mapRoute.reload")}
    >
      <Suspense fallback={
        <div role="status" aria-live="polite" className="flex min-h-[50vh] items-center justify-center gap-3 text-white">
          <span aria-hidden="true" className="h-5 w-5 animate-spin rounded-full border-2 border-white/30 border-t-white" />
          {t("mapRoute.loading")}
        </div>
      }>
        <MapSearch {...props} />
      </Suspense>
    </MapRouteBoundary>
  );
}
